<span
    class="em-icon-badge header-icon d-flex align-items-center justify-content-center ml-2 cursor-pointer"
    (click)="open()"
    [matBadge]="itemCount"
    matBadgeColor="accent"
    [matBadgeHidden]="!itemsExist"
>
    <em class="fas fa-shopping-cart"></em>
</span>
